import { Close, InstallDesktop } from '@mui/icons-material';
import { IconButton, Snackbar } from '@mui/material';
import { useAppContext } from 'App/AppContext';
import useInstallPrompt from 'hooks/UseInstallPrompt';
import React from 'react';

const InstallContainer = ({ title }) => {
    const { appInstalledSkipped, setAppInstalledSkipped } = useAppContext()
    const { deferredPrompt, setDeferredPrompt } = useInstallPrompt()

    // useEffect(() => {
    //     console.log(111)
    //     const handleBeforeInstallPrompt = (event) => {
    //         console.log(222)
    //         event.preventDefault()
    //         setDeferredPrompt(event)
    //         setShowInstall(true)
    //     };

    //     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    //     return () => {
    //         window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt)
    //         setDeferredPrompt(null)
    //     }
    // }, [])

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt()
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    setAppInstalledSkipped(false)
                    console.log('User accepted the install prompt')
                } else {
                    setAppInstalledSkipped(true)
                    console.log('User dismissed the install prompt')
                }
                setDeferredPrompt(null)
            });
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setAppInstalledSkipped(true)
        setDeferredPrompt(null)
    }

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="refresh"
                color="inherit"
                onClick={handleInstallClick}
            >
                <InstallDesktop fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <Close fontSize="small" />
            </IconButton>
        </React.Fragment>
    )

    if (appInstalledSkipped) {
        return null
    }

    return (
        <Snackbar
            open={deferredPrompt ? true : false}
            onClose={handleClose}
            message={<div>{title}</div>}
            action={action}
        />
    )
};

export { InstallContainer }